module.exports = __webpack_public_path__ + "img/progress_008.44672fe8.png";